import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/persons/resetB2BUserPasswordWithApiKey', request)
}

export {post}
